import { NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatSelectChange, MatSelect, MatOption } from '@angular/material/select';

import { TranslatePipe } from '@next/core-lib/i18n';

import {
  BodyConditionType,
  FeedAdviceProperties,
  FeedAdviceType,
  GeneticLineType,
} from '../../../models/feed-advice.model';

@Component({
  selector: 'app-sows-feed-advice-properties',
  templateUrl: './sows-feed-advice-properties.component.html',
  styleUrls: ['./sows-feed-advice-properties.component.scss'],
  imports: [
    NgIf,
    MatSelect,
    ReactiveFormsModule,
    FormsModule,
    NgFor,
    MatOption,
    MatInput,
    TranslatePipe,
  ],
})
export class SowsFeedAdvicePropertiesComponent implements OnInit {
  @Input() feedAdviceType: FeedAdviceType;
  @Input() bodyCondition: BodyConditionType;
  @Input() geneticLine: GeneticLineType;
  @Input() pigletsPerFarrowingCategory: number;
  @Input() transitionDay: number;

  @Output()
  propertiesChanged: EventEmitter<FeedAdviceProperties> = new EventEmitter<FeedAdviceProperties>();
  formGroup: FormGroup;

  bodyConditionTypes: string[] = Object.values(BodyConditionType);
  geneticLineTypes: string[] = Object.values(GeneticLineType);
  pigletsPerFarrowingCategories: number[] = Object.values([11, 12, 13, 14, 15]);

  constructor() {}

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      transitionDay: new FormControl(this.transitionDay, [
        Validators.required,
        Validators.min(1),
        Validators.max(115),
      ]),
    });
  }

  get transitionDayFormControl() {
    return this.formGroup.get('transitionDay');
  }

  selectGeneticLine($event: MatSelectChange) {
    this.geneticLine = $event.value;
    this.changeProperties();
  }

  changeProperties() {
    this.propertiesChanged.emit({
      feedAdviceType: this.feedAdviceType,
      bodyCondition: this.bodyCondition,
      geneticLine: this.geneticLine,
      pigletsPerFarrowingCategory: this.pigletsPerFarrowingCategory,
      transitionDay: this.formGroup.value.transitionDay,
    });
  }

  clearProperties() {
    this.bodyCondition = null;
    this.geneticLine = null;
    this.pigletsPerFarrowingCategory = null;
    this.transitionDay = null;
  }
}
